import React, { RefObject, useRef } from 'react'
import {
    StyledModal,
    StyledIconCrossSpanWrapper,
    StyledIconCross,
} from './LatestEdition.styled'
import {
    createEditionSelectItemEvent,
    formattedBrandNames,
    Issue,
} from '@news-mono/web-common'
import { format } from 'date-fns'
import {
    StyledEditionGroupButton,
    StyledEditionGroupContainer,
    StyledEditionGroupHeader,
    StyledEditionGroupImage,
    StyledEditionGroupModalMain,
    StyledEditionGroupPaperContainer,
    StyledEditionGroupTitle,
} from './EditionGroupModal.styled'
import { getMastheadMetadataFromMastheadName } from './EpaperCollection'
import { useProduct } from '../../../__product'

export interface EditionGroupModalProps {
    showEditionGroupModal: boolean
    setShowEditionGroupModal: (showModal: boolean) => void
    handleClickOutsideModal: (e: React.MouseEvent<HTMLDivElement>) => void
    innerModalRef: React.MutableRefObject<null>
    crossIconRef: RefObject<HTMLButtonElement>
    editionData: Issue
    onEvent: (event: any) => void
}

export const EditionGroupModal: React.FC<EditionGroupModalProps> = ({
    showEditionGroupModal,
    setShowEditionGroupModal,
    handleClickOutsideModal,
    innerModalRef,
    crossIconRef,
    editionData,
    onEvent,
}) => {
    const product = useProduct()

    const magazine = editionData.magazine

    return (
        <StyledModal
            showModal={showEditionGroupModal}
            onClick={handleClickOutsideModal}
        >
            <StyledEditionGroupModalMain
                className="modal-main"
                ref={innerModalRef}
            >
                <StyledIconCrossSpanWrapper
                    tabIndex={0}
                    ref={crossIconRef}
                    onClick={() => {
                        setShowEditionGroupModal(false)
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            setShowEditionGroupModal(false)
                        }
                    }}
                >
                    <StyledIconCross />
                </StyledIconCrossSpanWrapper>
                <StyledEditionGroupHeader>{`${format(
                    editionData.date,
                    'EEEE, d MMMM yyyy',
                )}`}</StyledEditionGroupHeader>
                <StyledEditionGroupPaperContainer>
                    <StyledEditionGroupContainer>
                        <StyledEditionGroupTitle>
                            {
                                getMastheadMetadataFromMastheadName(
                                    editionData.publicationName,
                                )?.mastheadName
                            }
                        </StyledEditionGroupTitle>
                        <StyledEditionGroupImage
                            src={editionData.coverUrl}
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null
                                currentTarget.src = require('../assets/paper.jpg')
                            }}
                            style={{ outline: '1px solid #D6D6D6' }}
                        />
                        <StyledEditionGroupButton
                            to={editionData.url}
                            onClick={() => {
                                onEvent(
                                    createEditionSelectItemEvent({
                                        issue: editionData,
                                        collectionName: `${product}EditionPage`,
                                        product,
                                        itemDetails: {
                                            category: `editions_page_${'latest_editions'}`,
                                            linkText: 'image',
                                            linkUrl: editionData.url,
                                            itemName: `${formattedBrandNames.get(
                                                editionData.publicationName,
                                            )} - ${format(
                                                new Date(editionData.date),
                                                'd MMM yyyy',
                                            )}`,
                                        },
                                    }),
                                )
                            }}
                        >
                            Read
                        </StyledEditionGroupButton>
                    </StyledEditionGroupContainer>
                    {magazine && (
                        <StyledEditionGroupContainer>
                            <StyledEditionGroupTitle>
                                {
                                    getMastheadMetadataFromMastheadName(
                                        magazine.publicationName,
                                    )?.mastheadName
                                }
                            </StyledEditionGroupTitle>
                            <StyledEditionGroupImage
                                src={magazine.coverUrl}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null
                                    currentTarget.src = require('../assets/paper.jpg')
                                }}
                            />
                            <StyledEditionGroupButton
                                to={magazine.url}
                                onClick={() => {
                                    onEvent(
                                        createEditionSelectItemEvent({
                                            issue: magazine,
                                            collectionName: `${product}EditionPage`,
                                            product,
                                            itemDetails: {
                                                category: `editions_page_${'latest_editions'}`,
                                                linkText: 'image',
                                                linkUrl: magazine.url,
                                                itemName: `${formattedBrandNames.get(
                                                    magazine.publicationName,
                                                )} - ${format(
                                                    new Date(magazine.date),
                                                    'd MMM yyyy',
                                                )}`,
                                            },
                                        }),
                                    )
                                }}
                            >
                                Read
                            </StyledEditionGroupButton>
                        </StyledEditionGroupContainer>
                    )}
                </StyledEditionGroupPaperContainer>
            </StyledEditionGroupModalMain>
        </StyledModal>
    )
}
